export default __webpack_public_path__ + "47692505d122dbcae490be2492a60b2e.png";